module.exports = __webpack_public_path__ + "img/1200px-RSI_logo.svg.1f689bcc.png";